"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chain = void 0;
const _ = __importStar(require("lodash"));
const _1 = require(".");
const DEFAULTS = {
    mode: 'mapReduce',
    separator: ' ',
    formatterContext: 'row'
};
function getExportValue(formatter, row, cell, value, columnDef, data, grid) {
    if (formatter.skipExport) {
        return;
    }
    if (formatter.exportDataFormatter) {
        return formatter.exportDataFormatter(row, cell, value, columnDef, data, grid);
    }
    if (formatter.exportRawData) {
        return value;
    }
    return formatter(row, cell, value, columnDef, data, grid);
}
function getFilterValue(formatter, row, cell, value, columnDef, data, grid) {
    if (formatter.filterRawData) {
        return value;
    }
    if (formatter.getCellValue) {
        return formatter.getCellValue(row, cell, value, columnDef, data, grid);
    }
    return formatter(row, cell, value, columnDef, data, grid);
}
function joinChainFormatter(opts) {
    const formatters = _.map(opts.formatters, item => (0, _1.getFormatterFactory)(item.name)(item.opts || item));
    const formatter = (row, cell, value, columnDef, data, grid) => {
        return _.map(formatters, fn => fn(row, cell, value, columnDef, data, grid)).join(opts.separator);
    };
    formatter.exportDataFormatter = (row, cell, value, columnDef, data, grid) => {
        return _.reduce(formatters, (arr, fn) => {
            const result = getExportValue(fn, row, cell, value, columnDef, data, grid);
            if (result !== null) {
                arr.push(result);
            }
            return arr;
        }, []).join(opts.separator);
    };
    formatter.getCellValue = (row, cell, value, columnDef, data, grid) => {
        return _.reduce(formatters, (arr, fn) => {
            const result = getFilterValue(fn, row, cell, value, columnDef, data, grid);
            if (result !== null) {
                arr.push(result);
            }
            return arr;
        }, []).join(opts.separator);
    };
    return formatter;
}
function mapReduceFormatter(opts) {
    const formatters = _.map(opts.formatters, item => (0, _1.getFormatterFactory)(item.name)(item.opts || item));
    const separator = opts.separator || '';
    const formatterContext = opts.formatterContext || DEFAULTS.formatterContext;
    const useRowAsContext = formatterContext === 'row';
    const formatter = (row, cell, value, columnDef, data, grid) => {
        if (_.isArray(value)) {
            return _.map(value, val => _.reduce(formatters, (m, fn) => fn(row, cell, m, columnDef, useRowAsContext ? data : val, grid), val)).join(separator);
        }
        return _.reduce(formatters, (m, fn) => fn(row, cell, m, columnDef, useRowAsContext ? data : value, grid), value);
    };
    formatter.exportDataFormatter = (row, cell, value, columnDef, data, grid) => {
        if (_.isArray(value)) {
            return _.chain(value)
                .map(val => _.reduce(formatters, (m, fn) => fn.skipExport
                ? m
                : getExportValue(fn, row, cell, m, columnDef, data, grid), val))
                .filter(p => p !== null)
                .value()
                .join(separator);
        }
        return _.reduce(formatters, (m, fn) => fn.skipExport
            ? m
            : getExportValue(fn, row, cell, m, columnDef, data, grid), value);
    };
    formatter.getCellValue = (row, cell, value, columnDef, data, grid) => {
        if (_.isArray(value)) {
            return _.chain(value)
                .map(val => _.reduce(formatters, (m, fn) => fn.skipFilter
                ? m
                : getExportValue(fn, row, cell, m, columnDef, data, grid), val))
                .filter(p => p !== null)
                .value()
                .join(separator);
        }
        return _.reduce(formatters, (m, fn) => fn.skipExport
            ? m
            : getExportValue(fn, row, cell, m, columnDef, data, grid), value);
    };
    return formatter;
}
function chain(opts) {
    const v = { ...DEFAULTS, ...opts };
    return v.mode === 'mapReduce' ? mapReduceFormatter(v) : joinChainFormatter(v);
}
exports.chain = chain;
//# sourceMappingURL=chain.js.map